





























































import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapActions } from 'vuex';
import { Action } from 'vuex-class';
import notificationService from '@/services/notificationService';
import cCard from '@/components/default/Card.vue';
import cDatagrid from '@/components/default/Datagrid.vue';
import axios from 'axios';
import cPopup from '@/components/default/Popup.vue';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxItem,
  DxLabel,
} from 'devextreme-vue/form';

import {
  DxDataGrid,
  DxEditing,
  DxStateStoring,
} from 'devextreme-vue/data-grid';

import store from '../../stores/store';

@Component({
  computed: {
    ...mapState('projects', {
      statusses: 'statusses',
      loading: 'loading',
      saving: 'saving',
    }),
  },
  methods: {
    ...mapActions('projects', {
      fetchData: 'fetch',
      create: 'createStatus',
      update: 'updateStatus',
      updateMultipleOrder: 'updateMultipleStatussesOrder',
      remove: 'deleteStatus',
    }),
  },
  components: {
    DxDataGrid,
    DxEditing,
    DxStateStoring,
    cCard,
    cDatagrid,
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxItem,
    DxLabel,
  },
})
export default class UsersOverview extends Vue {
  private statusses!: IProjectStatus[];
  private loading!: boolean;
  private showDeletePopup: boolean = false;
  private deleteModel: any = {
    oldValue: null,
    newValue: 0,
  };

  private fetchData!: any;
  private create!: any;
  private update!: any;
  private updateMultipleOrder!: any;
  private remove!: any;

  private async mounted() {
    try {
      this.fetchData();
    } catch (err) {
      notificationService.failedToLoad();
    }
  }

  private hideDialog() {
    this.showDeletePopup = false;
  }

  private addRow() {
    this.GridInstance.addRow();
  }

  private initRow(e: any) {
    e.data.value = 0;
  }

  private createRow(e: any) {
    const self = this;
    e.cancel = new Promise(async (resolve, reject) => {
      // eslint-disable-next-line
      const success = await self.create(e.data as IProjectStatus);
      if (success) {
        self.GridInstance.cancelEditData();
      }
      resolve(true);
    });
  }

  private async updateRow(e: any) {
    // Create updated object
    const updatedObject: IProjectStatus = Object.assign({}, e.oldData as IProjectStatus, e.newData);
    const self = this;
    // promise required for cancel
    e.cancel = new Promise(async (resolve, reject) => {
      const success = await self.update(updatedObject);
      if (success) {
        self.GridInstance.cancelEditData();
      }
      resolve(!success);
    });
  }

  private deleteRow(e: any) {
    this.deleteModel.oldValue = e.data.value;
    this.showDeletePopup = true;
    e.cancel = true;
  }

  private deleteStatus() {
    this.remove(this.deleteModel);
    this.showDeletePopup = false;
  }

  get columns() {
    return [
      {
        dataField: 'value',
        caption: this.$t('objects.projects.statusObj.Value'),
        allowEditing: false,
      },
      {
        dataField: 'name',
        caption: this.$t('objects.projects.statusObj.Name'),
      },
      {
        dataField: 'status',
        caption: this.$t('objects.projects.statusObj.Status'),
        lookup: {
          dataSource: this.projectStatusses,
          displayExpr: 'text',
          valueExpr: 'value',
        },
      },
    ];
  }

  get items(){
    const statusses = this.$store.getters['projects/statusses'] as IProjectStatus[];
    return statusses;
  }

  get rowDragging(){
    const self = this;
    return {
      allowReordering: true,
      onReorder(e:any){
        const visibleRows = e.component.getVisibleRows();
        const toIndex = self.statusses.indexOf(visibleRows[e.toIndex].data);
        const fromIndex = self.statusses.indexOf(e.itemData);
        const newList = [...self.statusses];

        newList.splice(fromIndex, 1);
        newList.splice(toIndex, 0, e.itemData);
        // self.$store.commit('projects/setStatusses', newList)
        self.updateMultipleOrder(newList);
      }
    };
  }

  get statusOptions() {
    return { items: this.statusses, valueExpr: 'value', displayExpr: 'name' };
  }

  get projectStatusses() {
    return [
      {
        value: 0,
        text: this.$t('objects.projects.statusObj.Statusses.0'),
      },
      {
        value: 3,
        text: this.$t('objects.projects.statusObj.Statusses.3'),
      },
      {
        value: 4,
        text: this.$t('objects.projects.statusObj.Statusses.4'),
      },
      {
        value: 5,
        text: this.$t('objects.projects.statusObj.Statusses.5'),
      },
      {
        value: 7,
        text: this.$t('objects.projects.statusObj.Statusses.7'),
      },
      {
        value: 8,
        text: this.$t('objects.projects.statusObj.Statusses.8'),
      },
      {
        value: 9,
        text: this.$t('objects.projects.statusObj.Statusses.9')
      }
    ];
  }

  get GridInstance() {
    return ((this.$refs.grid as Vue).$refs.projectstatussesTable as any)
      .instance;
  }
}
